import e from 'cors';
import Service from '../../service/Service';
const service = new Service();
var countimg = 0;
var countpdf = 0;
var img_flag = false;
var pdf_flag = false;
var file_array = [];
var commentDocUrl = "[]";
var isQuestion = false;



export function closeQuestionPopup(event, eleRef) {
    if (event.target.classList.contains('askQuest-overlay') || event.target.classList.contains('closeButton')) {
        clearQuestionPopupData(eleRef);
    }
}

function clearQuestionPopupData(eleRef) {
    console.log('---------------1');
    eleRef.setState({showAskQueModal: false});
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
    document.getElementsByTagName('body')[0].classList.remove("bodyOverflow");
    hideFileError('askQuest-overlay');
    eleRef.setState({similarQueRecomm : []});
    countimg = 0;
    countpdf = 0;
    img_flag = false;
    pdf_flag = false;
    file_array = [];
    commentDocUrl = "[]";
    document.getElementById('post_question_text').value = '';

    if(window.innerWidth < 768)
        document.querySelector(".postque-text textarea").style.height = "50%";
        
    eleRef.setState({ selectedChildId: 0 });
    var fileEle = document.getElementsByClassName('askQuest-overlay')[0];
    fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "none";
    fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    fileEle.getElementsByClassName('cmt-image')[0].style.display = "none";
    fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    // added-file-name
    isQuestion = false;
}

export function getChildAge(dob) {
    var now = new Date();
    var yearNow = now.getYear();
    var monthNow = now.getMonth();
    var dateNow = now.getDate();

    var dob = new Date(dob);
    var yearDob = dob.getYear();
    var monthDob = dob.getMonth();
    var dateDob = dob.getDate();

    var age = {};

    var yearAge = yearNow - yearDob;

    if (monthNow >= monthDob) {
        var monthAge = monthNow - monthDob;
    } else {
        yearAge--;
        var monthAge = 12 + monthNow - monthDob;
    }

    if (dateNow >= dateDob) {
        var dateAge = dateNow - dateDob;
    } else {
        monthAge--;
        var dateAge = 31 + dateNow - dateDob;
        if (monthAge < 0) {
            monthAge = 11;
            yearAge--;
        }
    }

    age = {
        years: yearAge,
        months: monthAge,
        days: dateAge
    };

    var ageString = '';
    if (yearAge > 0) {
        if (yearAge > 1) {
            ageString = yearAge + ' yrs old';
        } else {
            ageString = yearAge + ' yr old';
        }
    } else if (yearAge <= 0 && monthAge > 0) {
        if (monthAge > 1) {
            ageString = monthAge + ' months old';
        } else {
            ageString = monthAge + ' month old';
        }
    } else if (yearAge <= 0 && monthAge <= 0 && dateAge > 0) {
        if (dateAge > 1) {
            ageString = dateAge + ' days old';
        } else {
            ageString = dateAge + ' day old';
        }
    }
    return ageString;
}

export function getShortAge(dob) {
    var now = new Date();
    var yearNow = now.getYear();
    var monthNow = now.getMonth();
    var dateNow = now.getDate();

    var dob = new Date(dob);
    var yearDob = dob.getYear();
    var monthDob = dob.getMonth();
    var dateDob = dob.getDate();

    var age = {};

    var yearAge = yearNow - yearDob;

    if (monthNow >= monthDob) {
        var monthAge = monthNow - monthDob;
    } else {
        yearAge--;
        var monthAge = 12 + monthNow - monthDob;
    }

    if (dateNow >= dateDob) {
        var dateAge = dateNow - dateDob;
    } else {
        monthAge--;
        var dateAge = 31 + dateNow - dateDob;
        if (monthAge < 0) {
            monthAge = 11;
            yearAge--;
        }
    }

    age = {
        years: yearAge,
        months: monthAge,
        days: dateAge
    };

    var ageString = '';
    if (yearAge > 0) {
        if (yearAge > 1) {
            ageString = yearAge + 'y old';
        } else {
            ageString = yearAge + 'y old';
        }
    } else if (yearAge <= 0 && monthAge > 0) {
        if (monthAge > 1) {
            ageString = monthAge + 'm old';
        } else {
            ageString = monthAge + 'm old';
        }
    } else if (yearAge <= 0 && monthAge <= 0 && dateAge > 0) {
        if (dateAge > 1) {
            ageString = dateAge + ' days old';
        } else {
            ageString = dateAge + ' day old';
        }
    }
    return ageString;
}


export function saveQuestion(childId, eleRef) {

    // console.log('--------------------childId:', childId);
    if (global.ftk != '') {
        // if ((global.userAry['Sex'] == "" || global.userAry['Sex'] == null) && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length >=1) {
        //     service.showAlert("Please Complete Your Profile");
        //         window.location.href = '/my-account?URL=' + global.currentURL;
        //         return false;
        // } else {

        const uploadedImageUrl = eleRef.state.uploadedImageUrl || '';

        if (uploadedImageUrl) {
            file_array.push({
                url: uploadedImageUrl,
                height: 10,
                width: 10
            });

            commentDocUrl = JSON.stringify(file_array);
        }


        service.gardianProfileChk();
        let askQuestion = document.getElementById('post_question_text').value.trim();
        if (!askQuestion || askQuestion == '') {
            showFileError('askQuest-overlay', "Please type your question");
            return false;
        } else if (childId == 0) {
            showFileError('askQuest-overlay', "Please select a child");
            return false;
        } else {
            // hideFileError('askQuest-overlay');
            service.showLoader();
            if (childId != "all") {
                let childAry = global.userAry['childData']['UserChildList'].filter(function (item) {
                    return childId == item.ChildId;
                });
                console.log('----------------childAry-',childAry);
                var postData = {
                    "childinfo": getChildPostAry(childAry),
                    "question_type": 1,
                    "user_type": global.userAry['Sex'],
                    "que_type": "child",
                    "docUrls": JSON.parse(commentDocUrl),
                    "question_title": askQuestion,
                    "expecting_dob": global.userAry['expectedDob'],
                    "IsTryingToConceive": global.userAry['IsTryingToConceive']
                }
            } else {
                var postData = {
                    "childinfo": getChildPostAry(global.userAry['childData']['UserChildList']),
                    "question_type": 1,
                    "user_type": global.userAry['Sex'],
                    "que_type": "myself",
                    "docUrls": JSON.parse(commentDocUrl),
                    "question_title": askQuestion,
                    "expecting_dob": global.userAry['expectedDob'],
                    "IsTryingToConceive": global.userAry['IsTryingToConceive']
                }
            }
            var url = global.api_ci_url + "api/fetchfromCI/saveQuestion";
            console.log('URL for saveQuestion:---------', url); //api/fetchfromCI/saveAnsAction
            // let url = global.api_ci_url + "api/fetchfromCI/saveAnsAction";
            // console.log('Post data for saveQuestion:------------', postData);
            service.postServiceCall(url, postData).then((json) => {
                console.log("------------------------saveQuestion---------------------", json)
                if (json['success'] == "1") {

                    eleRef.setState({ childIdQuePost: 0 });
                    service.showAlert("Question Posted successfully");
                    clearQuestionPopupData(eleRef);
                    // if (!eleRef.state.isPisPage) {
                    //     eleRef.props.history.push("/qna/intentmapping/" + service.genquestionurl(askQuestion) + '-' + (json['queId']));
                    // } else {
                    //     service.hideLoader();
                    // }
                    if (!eleRef.state.isPisPage) {
                        
                        if(json['queId'] && json['queId'] != ""){
                            
                            eleRef.props.history.push("/qna/intentmapping/" + service.genquestionurl(askQuestion) + '-' + (json['queId']));

                        }else{
                            service.showAlert("Please enter a valid question"); 
                        }
                        service.hideLoader();
                    } else {
                        service.showAlert("Please enter a valid question"); 
                        service.hideLoader();
                    }
                }
                else{

                }
                // service.hideLoader();
            }).catch((error) => {
                // console.error(error);
                service.hideLoader();
            });
            return true;
        }
    // }
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function cmtFileDelete(type, key) {
    let mainEle = document.getElementsByClassName("addAns-overlay")[0];
    let mainClass = 'addAns-overlay';
    if (key == "que") {
        mainEle = document.getElementsByClassName("askQuest-overlay")[0];
        mainClass = 'askQuest-overlay';
    } else if (key == "topics") {
        mainEle = document.getElementsByClassName("participate-overlay")[0];
        mainClass = 'participate-overlay';
    }
    hideFileError(mainClass);
    for (var i = 0; i < file_array.length; i++) {
        if (type == 'pdf') {
            if (file_array[i]['url'].split('.').pop() == 'pdf') {
                file_array.splice(i, 1);
            }
        } else {
            if (file_array[i]['url'].split('.').pop() != 'pdf') {
                file_array.splice(i, 1);
            }
        }
    }
    commentDocUrl = JSON.stringify(file_array);
    if(key =="ans"){
        document.getElementById("fileupload_ans").value = '';
        
    }else if(key =="que"){
        document.getElementById("fileupload_askq").value = '';
    }else{
        document.getElementById("fileupload").value = '';
    }
    
    var fileEle = mainEle.getElementsByClassName('uploaded-files-list')[0];
    if (type == "pdf") {
        countpdf--;
        pdf_flag = false;
        fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "none";
        fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    } else {
        countimg--;
        img_flag = false;
        fileEle.getElementsByClassName('cmt-image')[0].style.display = "none";
        fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    }
}

function showFileError(mainClass, msg) {
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "visible";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.display = "inline-block";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = msg;
    service.hideLoader();
}

function hideFileError(mainClass) {
    console.log('---------------------5', mainClass);
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "hidden";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.display = "none";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = "";
    console.log('---------------------6');
}

export function cmtFileUploadMyAns(eleRef) {

    var mainClass = 'addAns-overlay';
    if (isQuestion) {
        // console.log('isQuestion true');
        mainClass = 'askQuest-overlay';
    }else{
        // console.log('isQuestion false');
    }
    var fileObj = document.getElementById("fileupload_askq").files[0];
    console.log('fileObj:', fileObj);
    var fname = Math.round(new Date().getTime() / 1000);
    var file_name = "";
    var apiurl = "";
    if(!fileObj){
        return;
    }
    if(navigator.onLine){
        service.showLoader();
        if ((fileObj.type == "image/jpg" || fileObj.type == "image/jpeg" || fileObj.type == "image/png") && fileObj.size < 5242880) {
            file_name = Math.round(new Date().getTime() / 1000) + ".jpg";
            img_flag = true;
            countimg++;
            apiurl = global.api_ci_url + "Parenting/uploadMemoryImage";
        } else if (fileObj.type == "application/pdf" && fileObj.size < 5242880) {
            file_name = Math.round(new Date().getTime() / 1000) + ".pdf";
            pdf_flag = true;
            countpdf++;
            apiurl = global.api_ci_url + "Parenting/uploadFilesToCommunity";
        } else {
            // countimg = 0;
            // countpdf = 0;
            apiurl = "";
            showFileError("askQuest-overlay", "Only JPEG, JPG, PNG and PDF files allowed of less than 5 MB");
            return;
        }
        if ((img_flag && countimg == 1) || (pdf_flag && countpdf == 1)) {
            hideFileError("askQuest-overlay");
            service.postFileServiceCall(apiurl, fileObj, file_name).then((json) => {
                if (json["result"] == 'success') {
                    file_array.push({
                        "url": json["image_url"],
                        "height": 10,
                        "width": 10
                    });
                    commentDocUrl = JSON.stringify(file_array);
                    var fileEle = document.getElementsByClassName("askQuest-overlay")[0].getElementsByClassName('uploaded-files-list')[0];
                    if (fileObj.type == "application/pdf") {
                        fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "flex";
                        fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = file_name;
                        pdf_flag = false;
                    } else {
                        fileEle.getElementsByClassName('cmt-image')[0].style.display = "flex";
                        fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = file_name;
                        img_flag = false;
                    }
                    // debugger;
                    document.getElementById("fileupload_askq").value = '';
                } else {
                    service.showAlert("Fail 5");
                }
                service.hideLoader();
            }).catch((error) => {
                if (fileObj.type == "application/pdf") {
                    countpdf = 0;
                    pdf_flag = false;
                } else {
                    countimg = 0;
                    img_flag = false;
                }
                service.showAlert("File too large or something went wrong");
                console.error(error);
                service.hideLoader();
            });
        } else {
            if(countimg > 1){
                countimg--;
                img_flag = false;
            }
            if(countpdf > 1){
                countpdf--;
                pdf_flag = false;
            }
            showFileError("askQuest-overlay", "Only 1 image can be uploaded & only 1 pdf can be uploaded");
            service.hideLoader();
            return;
        }
    } else {
        document.getElementById("fileupload_askq").value = '';
        service.showAlert("Please check internet connection");
    }

    


    


    
}

function getChildPostAry(reqAry) {
    let resAry = [];
    for (let c = 0; c < reqAry.length; c++) {
        let obj = {};
        obj['id'] = reqAry[c]['ChildId'];
        obj['gender'] = reqAry[c]['Gender'].toLowerCase();
        obj['childdob'] = reqAry[c]['DOB'];
        resAry.push(obj);
    }
    return resAry;
}

export function loadCallbackFile() {
    console.log('----------------1');
    new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = "https://cdn.cdnparenting.com/brainbees/community/preactProd/public/callbacks-V1.js?v2.91";
        script.addEventListener('load', function () { resolve(); });
        script.addEventListener('error', function (e) { reject(e); });
        document.body.appendChild(script);
    }).then(function () {
        console.log("loaded callbacks.js");
    }).catch(function () {
        console.log("error loading callbacks.js");
    })
}
